import React, {useEffect} from 'react';
import Box from "@mui/material/Box";
import Authenticated from "../components/Authenticated";
import Login from "../components/Login";
import Typography from "@mui/material/Typography";
import {useSelector} from "react-redux";
import MyEvents from "./MyEvents";
import Calendar from "./Calendar";
import Event from "./Event";
import {useNavigate} from "react-router-dom";


export default function Home () {

    const session = useSelector(state => state.session)
    const navigate = useNavigate()

    const [homePage, setHomePage] = React.useState()

    useEffect(() => {
        if (session && session.scope) {
            if (session.scope.includes('SERVICE_SGP_ADMIN')) {
                setHomePage('calendar')
            } else if (session.scope.includes('SERVICE_SGP_SCORING') || session.scope.includes('SERVICE_SGP_MANAGER')) {
                navigate('event')
            } else {
                setHomePage('myEvents')
            }
        }
    }, [session?.scope]);

    const notAuthenticatedView = () => {
        return (
            <Box>
                <Box sx={{
                    minHeight: 'calc(100vh - 0px)',
                    display: 'flex',
                    alignItems: 'stretch',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center center',
                    backgroundSize: 'cover',
                    backgroundImage: 'url("/etc/home-img/photo-0002.jpg")'
                }}>
                    <Box flexGrow={1} sx={{
                        display:'flex',
                        flexDirection:'column',
                        alignItems:'center',
                        justifyContent:'space-between',
                        background:'#00000077',
                    }}>
                        <Box sx={{
                            py:'2em',
                        }}>
                            <Box>
                                <img src={'/etc/img/cc-stadium-logo-white.png'} style={{width:'35em'}}/>
                            </Box>
                            <Typography variant={'h3'} component={'h2'} sx={{color:'#ffffff',fontSize:'1.6rem'}} mt={1}>
                                Competition management made easy
                            </Typography>
                        </Box>
                        <Box sx={{
                            py:'2em',
                            color:'#ffffff',
                        }}>
                            <Box>
                                <img src={'/etc/img/sgp-series-logo-v3.png'} style={{width:'12em'}}/>
                                <Typography variant={'body2'}>OFFICIAL SCORING PARTNER</Typography>
                            </Box>
                        </Box>
                    </Box>
                    <Box flexGrow={2} sx={{
                        display:'flex',
                        flexDirection:'column',
                        justifyContent:'center',
                        alignItems:'center',
                    }}>
                        <Box sx={{
                            bgcolor:'#ffffff',
                            p:'1.5em 1.5em',
                        }}>
                            <Login/>
                        </Box>
                    </Box>
                </Box>
            </Box>
        )
    }


    return (
        <Authenticated notAuthenticatedView={notAuthenticatedView()}>
            { homePage === 'calendar' &&
                <Calendar/>
            }
            { homePage === 'myEvents' &&
                <MyEvents/>
            }
        </Authenticated>
    )
}